// src/components/calendar/calendarView.js
import FullCalendar from "@fullcalendar/react";
import dayGridPlugin from "@fullcalendar/daygrid";
import timeGridPlugin from "@fullcalendar/timegrid";
import interactionPlugin from "@fullcalendar/interaction";
import listPlugin from "@fullcalendar/list";

import EventRenderer from "./eventRender";
import EventModal from "./eventModal";
import CalendarLegend from "./calendarLegend";

export default function CalendarView({
  events,
  searchTerm,
  setSearchTerm,
  calendarViews,
  headerToolbar,
  initialView,
  getTitleColor,
  formatDateTime,
  selectedEvent,
  setSelectedEvent,
  isModalOpen,
  setIsModalOpen,
}) {
  // Filter events by search term (title + extendedProps)
  const filteredEvents = events.filter((e) => {
    if (!searchTerm) return true;

    const term = searchTerm.toLowerCase();
    const values = [
      e.title,
      ...(e.extendedProps ? Object.values(e.extendedProps) : []),
    ]
      .filter(Boolean)
      .map((v) => String(v).toLowerCase());

    return values.some((v) => v.includes(term));
  });

  return (
    <div className="flex flex-col h-screen w-full p-4 bg-white">
      {/* Container for legend, search, and calendar */}
      <div className="flex flex-col h-full min-h-0">

        {/* Legend */}
        <div className="hidden md:block">
          <CalendarLegend />
        </div>

        {/* Search */}
        <div className="mt-2 mb-2 flex justify-start">
          <input
            type="text"
            placeholder="Search events..."
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            className="border rounded px-3 py-2 w-full sm:w-64 focus:outline-none focus:ring-2 focus:ring-blue-400"
          />
        </div>

        {/* Calendar */}
        <div className="flex-1 min-h-0">
          <FullCalendar
            plugins={[dayGridPlugin, timeGridPlugin, interactionPlugin, listPlugin]}
            initialView={initialView}
            views={calendarViews}
            headerToolbar={headerToolbar}
            height="100%"
            expandRows
            events={filteredEvents}
            eventClick={(clickInfo) => {
              const { title, extendedProps } = clickInfo.event;
              setSelectedEvent({
                id: clickInfo.event.id,
                title,
                start: clickInfo.event.start,
                ...extendedProps,
              });
              setIsModalOpen(true);
            }}
            eventContent={(eventInfo) => (
              <EventRenderer eventInfo={eventInfo} getTitleColor={getTitleColor} />
            )}
            eventMinHeight={30} // improves mobile visibility
            eventMaxStack={4}   // prevents overly tall stacks
          />
        </div>

        {/* Modal */}
        {isModalOpen && selectedEvent && (
          <EventModal
            selectedEvent={selectedEvent}
            isOpen={isModalOpen}
            onClose={() => setIsModalOpen(false)}
            formatDateTime={formatDateTime}
          />
        )}
      </div>
    </div>
  );
}